import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center ga-3 ga-sm-4 ga-md-6" }
const _hoisted_2 = { class: "d-flex flex-column ga-1 ga-md-4 flex-1-1-0" }
const _hoisted_3 = { class: "d-flex flex-column ga-1" }
const _hoisted_4 = { class: "token-name text-h3" }
const _hoisted_5 = {
  key: 0,
  class: "description"
}
const _hoisted_6 = { class: "d-flex flex-column ga-1 text-body-2 text-md-body-1" }
const _hoisted_7 = { class: "d-flex ga-1 flex-wrap" }
const _hoisted_8 = { class: "label opacity-60" }
const _hoisted_9 = { class: "d-flex ga-1 flex-wrap" }
const _hoisted_10 = { class: "label opacity-60" }


import { useLiveTokenData } from "@/composables";
import { TokenDto } from "@/api/generated";
import { ROUTE_TOKEN_DETAILS } from "@/utils/constants";

import PriceDataFormatter from "@/components/Common/Pricing/PriceDataFormatter.vue";
import TokenImage from "@/components/Tokens/TokenImage.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TokenListCard',
  props: {
  token: { type: Object as () => TokenDto, required: true },
},
  setup(__props) {

const props = __props;

const { tokenData } = useLiveTokenData({
  token: props.token,
});

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "token-list-card d-flex flex-column pa-2 pa-sm-3 pa-lg-5 align-items-start bg-transparent",
    variant: "outlined",
    to: {
      name: _unref(ROUTE_TOKEN_DETAILS),
      params: { tokenName: __props.token.symbol },
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(TokenImage, {
          cid: __props.token.image_thumbnail,
          class: "image"
        }, null, 8, ["cid"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.token.name) + " (" + _toDisplayString(__props.token.symbol) + ") ", 1),
            (__props.token.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.token.description), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("common.price")) + ":", 1),
              _createVNode(PriceDataFormatter, {
                "price-data": _unref(tokenData).price_data,
                "hide-fiat-price": ""
              }, null, 8, ["price-data"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("common.marketCap")) + ":", 1),
              _createElementVNode("span", null, [
                _createVNode(PriceDataFormatter, {
                  "price-data": _unref(tokenData).price_data,
                  bignumber: "",
                  row: "",
                  "hide-ae-price": ""
                }, null, 8, ["price-data"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})